import React, { createContext, useContext, useEffect } from "react";
import { Modal, Select, Form, notification, InputNumber, Spin } from "antd";
import WrfmSettingStore from "../../store/wrfmsettingstore";
import { toJS } from "mobx";
import { observer } from "mobx-react-lite";

const wrfmStoreCtx = createContext(WrfmSettingStore);
const { Option } = Select;
export const FlowstationCapacityDialog = observer(() => {
  const wrfmStore = useContext(wrfmStoreCtx);

  useEffect(() => {
    async function loadFlowStations() {
      try {
        await wrfmStore.loadFlowStations();
      } catch (error) {
        notification.error({
          message: "Feedback Manager",

          description: `Something went wrong.${error.message}.`,
        });
      }
    }
    loadFlowStations();
  }, []);

  return (
    <Modal
      visible={wrfmStore.showFlowsationCapcityDialog}
      onCancel={() => {
        wrfmStore.showFlowsationCapcityDialog = false;
      }}
      width={400}
      centered
      destroyOnClose={true}
      title={`${wrfmStore.action}  Flowstation Capacity`}
      onOk={async () => {
        try {
          const retVal = await wrfmStore.createMapping();
          wrfmStore.flowstationfields.set(retVal.flowstationFieldId, retVal);
          notification.success({
            message: "Feedback Manager",

            description: `mapping successfully created`,
          });
          wrfmStore.showFlowsationCapcityDialog = false;
        } catch (error) {
          notification.error({
            message: "Feedback Manager",

            description: `Something went wrong.${error.response.text}.`,
          });
        }
      }}
      okText={`${wrfmStore.action} Mapping`}
      okButtonProps={{
        disabled: !(
          toJS(wrfmStore.selCapacity)?.fieldName &&
          toJS(wrfmStore.selCapacity)?.flowstationName
        ),
        loading: wrfmStore.isSaving,
      }}
    >
      <Spin spinning={wrfmStore.isLoading} tip="Loading form data...">
        <Form layout="vertical">
        <Form.Item label="Flowstation" required>
          <Select
            showSearch
            style={{ width: "80%" }}
            placeholder="Select Flowstation"
            optionFilterProp="children"
            value={toJS(wrfmStore.selCapacity)?.flowstationId}
            onChange={(value, selItem) => {
              try {
                wrfmStore.selCapacity = {
                  ...wrfmStore.selCapacity,
                  flowstationId: value,
                  flowstation: selItem.children,
                };
                console.log(toJS(wrfmStore.selCapacity));
              } catch (error) {
                notification.error({
                  message: "SPARS Feedback",
                  description: `hirerachy loading failed`,
                });
              }

              // console.log(value)
            }}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {[...wrfmStore.flowstations.values()]
              .map((f) => toJS(f))
              .map((f) => (
                <Option value={f.flowstationId} key={f.flowstationName}>
                  {f.flowstationName} ({f.status})
                </Option>
              ))}
          </Select>
        </Form.Item>
        <Form.Item label="Oil Operating Capacity" required>
          <InputNumber
            min={0}
            style={{ width: "80%" }}
            placeholder="enter designed oil operating capacity"
          />
        </Form.Item>
        <Form.Item label="Gas Operating Capacity" required>
          <InputNumber
            min={0}
            style={{ width: "80%" }}
            placeholder="enter designed gas operating capacity"
          />
        </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
});

